import { render, staticRenderFns } from "./Cloze.vue?vue&type=template&id=db9a3cda&scoped=true&"
import script from "./Cloze.vue?vue&type=script&lang=js&"
export * from "./Cloze.vue?vue&type=script&lang=js&"
import style0 from "./Cloze.vue?vue&type=style&index=0&id=db9a3cda&scoped=true&lang=less&"
import style1 from "./Cloze.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a3cda",
  null
  
)

export default component.exports